import { Loader } from '@pocketlaw/tetris';
import { Container } from './styled';
export function Loading() {
    return (<Container>
      <Loader size={12}/>
    </Container>);
}
